import React from 'react';
import NormalConComponent from '@/page/conversation/NormalConComponent';

export default function ExternalPage() {
    return (
        <NormalConComponent
            receiveTabs={[{name: '员工', key: 2}]}
            sendType={0}
            title={'内部会话查询'}
            receiveTabs={[
                {name: '内部联系人', key: 2},
                {name: '内部群聊', key: 5},
            ]}
        />
    );
}
